import { get } from 'lodash';

export const getRoles = (state) => get(state, 'roles.roles');

export const isRoleFetching = (state) => get(state, 'roles.isRolesFetching');